export const UserActions = {
    SET_USER_LOGIN: 'setUserLogin',
    SET_USER_LOGOUT: 'setUserLogout'
}

export const User = {
    USER_OBJ_KEY: 'userinfo'
}
